/* eslint-disable complexity */
// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import SearchFilters from '../../../shared/state/search-filters';
import TranslatedInput from '../../../shared/components/translated-input';
import TranslatedOption from '../../../shared/components/translated-option';

const sortMap = {
    ASC: 'ascending',
    DESC: 'descending'
};

const handleSortDirectionChange = props => () => {

    const direction = props.searchFilters.sortDirection === 'ASC' ?
        'DESC' :
        'ASC';

    props.onSortDirectionChange(direction, props.type);

};

const handleFilterByChange = props => event => {

    const value = event.target.value.trim();

    props.onFilterByChange(value, props.type);

};

const handleSortByChange = props => event => {

    const option = event.target.value.split(',');

    props.onSortByChange(option, props.type);

};

const handleFilterByChangeOnKeyDown = props => event => {

    const value = event.target.value.trim();

    if (props.isAPIBasedSearchFilter) {

        if ((value.length > 0) && (event.key === 'Enter' || event.key === 'Tab')) {

            props.onSearchFilterChange(props.accounts, value, props.searchType);

        } else {

            props.onFilterByChange(value, props.type);

        }

    }

};

const RefinableListWidgetWithExport = props => {

    const sortClassName = sortMap[props.searchFilters.sortDirection];

    return (
        <div className='refinable-list'>
            <div className='rounded-bar-filter'>
                <span className='icon-search'/>
                <TranslatedInput
                    onChange={handleFilterByChange(props)}
                    onKeyDown={handleFilterByChangeOnKeyDown(props)}
                    placeholder='FILTER_PLACEHOLDER'
                    type='text'
                    value={props.searchFilters.filterBy}
                />
            </div>
            <div className='rounded-bar-sort'>

                <div className='sort-by-group'>
                    <label>
                        <FormattedMessage id='SORT_BY'/>
                    </label>
                    <select
                        onChange={handleSortByChange(props)}
                        value={props.searchFilters.sortBy.toString()}
                    >
                        {props.sortOptions.map(option =>
                            <TranslatedOption
                                key={option.displayName}
                                text={option.displayName}
                                value={String(option.path)}
                            />
                        )}
                    </select>
                    <button
                        className='button-text'
                        onClick={handleSortDirectionChange(props)}
                        type='button'
                    >
                        <span className={`sort-control ${sortClassName}`}/>
                    </button>
                </div>
            </div>
            {
                props.hasResults &&
                    <div className={'export-container'}>
                        <span
                            className={'excel-icon'}
                            onClick={props.onExport}
                        > </span>
                    </div>
            }
        </div>
    );

};

RefinableListWidgetWithExport.displayName = 'RefinableListWidget';
RefinableListWidgetWithExport.propTypes = {
    accounts: PropTypes.array,
    hasResults: PropTypes.bool,
    onExport: PropTypes.func.isRequired,
    onFilterByChange: PropTypes.func.isRequired,
    onSearchFilterChange: PropTypes.func,
    onSortByChange: PropTypes.func.isRequired,
    onSortDirectionChange: PropTypes.func.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchType: PropTypes.string,
    sortOptions: PropTypes.array.isRequired,
    type: PropTypes.func
};

RefinableListWidgetWithExport.defaultProps = {
    isAPIBasedSearchFilter: false
};

export default RefinableListWidgetWithExport;




// WEBPACK FOOTER //
// ./src/shared/components/refinable-list-widget/refinable-list-widget-with-export.js